var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',_vm._b({staticClass:"c-responsive-image",class:{ lazyload: _vm.isSSR ? _vm.lazyload && !_vm.fallback : _vm.useLazysizes }},'img',Object.assign({}, _vm.$attrs, _vm.attributes),false))}
var staticRenderFns = []

export { render, staticRenderFns }